<script setup
        lang="ts">
withDefaults(defineProps<{
    text: string;
    url: string;
    secondary?: boolean;
    contrast?: boolean;
    slim?: boolean;
}>(), {
    secondary: false,
    contrast:  false,
    slim:      false,
});
</script>

<template>
    <a :class="[
           'group',
           'relative',
           'inline-flex items-center',
           'text-base font-helvetica no-underline whitespace-nowrap select-none',
           'cursor-pointer',
           'transition-colors duration-200',
           {
               'text-primary-700 light:text-primary-900': !secondary && !contrast,
               'text-secondary-600': secondary && !contrast,
               'text-primary-700 light:text-primary-700': contrast,
           },
           {
               'hover:text-primary-500 light:hover:text-primary-700': !secondary && !contrast,
               'hover:text-secondary-500': secondary && !contrast,
               'hover:text-primary-500 light:hover:text-primary-500': contrast,
           },
           {
               'text-xs': slim,
           },
       ]"
       :href="url"
       target="_blank"
       rel="noopener noreferrer">
        <span :class="[
            'relative',
        ]">{{ text }}</span>
        <i :class="[
            'i-pixelarticons:external-link',
            'relative',
            'w-4',
            'ml-0.5',
        ]" />
    </a>
</template>
